// Temps réel du tableau de bord (2026-10-30).
//
// Le serveur pousse un événement « admin_event » à chaque notification admin enregistrée
// (nouveau chauffeur, nouveau commerce, document, ticket, SOS, commande, paiement…) et à
// chaque erreur nouvelle. Ici : une connexion socket par session admin, et un hook que les
// pages de liste utilisent pour se recharger sans attendre le polling de 30 s.
import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import apiService from './apiService';

const EVENT_NAME = 'mbiyo:admin-event';
let socket = null;

// Hôte du socket = l'API sans le suffixe /api.
function socketHost() {
  return String(apiService.baseURL || '').replace(/\/api\/?$/, '');
}

export function connectLive(token, onEvent) {
  disconnectLive();
  if (!token) return null;
  socket = io(socketHost(), {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnectionDelay: 2000,
    reconnectionDelayMax: 20000,
  });
  socket.on('admin_event', (payload) => {
    const detail = payload || {};
    try { onEvent?.(detail); } catch (_) {}
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail }));
  });
  socket.on('connect_error', (e) => console.warn('🔌 Socket admin :', e.message));
  return socket;
}

export function disconnectLive() {
  if (socket) { try { socket.disconnect(); } catch (_) {} }
  socket = null;
}

export function isLiveConnected() {
  return !!socket?.connected;
}

// Un type d'événement correspond-il aux filtres de la page ? 'driver_*' = préfixe.
function matches(detail, types) {
  if (!types || types.length === 0) return true;
  const t = detail.type || '';
  return types.some((f) => (f.endsWith('*') ? t.startsWith(f.slice(0, -1)) : f === t || f === detail.kind));
}

/**
 * useLiveRefresh(fn, types) — appelle fn (regroupé sur 400 ms) à chaque événement temps réel
 * dont le type figure dans `types` (ou tous si `types` est vide). fn peut changer d'identité
 * à chaque rendu : la dernière version est utilisée.
 */
export function useLiveRefresh(fn, types) {
  const ref = useRef(fn);
  ref.current = fn;
  const key = (types || []).join('|');
  useEffect(() => {
    let timer = null;
    const handler = (e) => {
      const detail = e.detail || {};
      if (!matches(detail, key ? key.split('|') : [])) return;
      clearTimeout(timer);
      timer = setTimeout(() => { try { ref.current(detail); } catch (_) {} }, 400);
    };
    window.addEventListener(EVENT_NAME, handler);
    return () => { window.removeEventListener(EVENT_NAME, handler); clearTimeout(timer); };
  }, [key]);
}
